// extracted by mini-css-extract-plugin
export default {"qsEntries":"qsEntries--38NmR","entry":"entry--td4FW","logo":"logo--15vZ4","title":"title--YbhSH","link":"link--2afN1"};